import {HttpErrorResponse,HttpResponse} from '@angular/common/http';
import {Component,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap} from '@angular/router';
import {IMyDateModel,IMyOptions} from 'mydatepicker';
import {JhiAlertService} from 'ng-jhipster';
import {BsModalRef,BsModalService,ModalDirective} from 'ngx-bootstrap';
import {Observable} from 'rxjs';
import {Principal} from 'src/app/core';
import {PackingTypeMySuffixService} from 'src/app/entities/packing-type-my-suffix';
import {ConfirmationModalComponent} from 'src/app/shared/confirmation-modal/confirmation-modal.component';
import {ConfirmationModelService} from 'src/app/shared/confirmation-modal/confirmation-model.service';
import {OrderPipe} from 'src/app/shared/custom-pipe/order.pipe';
import {FutureDataType} from 'src/app/shared/model/future_data_type.model';
import {ILoadingSubTypeDto,LoadingSubTypeDto} from 'src/app/shared/model/loading-subtype.model';
import {ILoadingTypeDto} from 'src/app/shared/model/loading-type-my-suffix.model';
import {IPackingTypeMySuffix} from 'src/app/shared/model/packing-type-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {CommonUtils} from 'src/app/shared/util/common-utils';
import {LoadingTypeMySuffixService} from './loading-type-my-suffix.service';



declare let $: any;

@Component({
    selector: 'jhi-loading-type-my-suffix-update',
    templateUrl: './loading-type-my-suffix-update.component.html',
    providers:[
        OrderPipe
    ]
})
export class LoadingTypeMySuffixUpdateComponent implements OnInit {

    @ViewChild('subTypeRelation') subTypeRelation: ModalDirective;

    private _loadingType: ILoadingTypeDto;
    isSaving: boolean;
    packingtypes: IPackingTypeMySuffix[];
    mocTypesList=[]
    isWarningShown :boolean = false;
    mocTypesDropdownSettings = {
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'meansOfConveyance',
        defaultOpen:false
    }

    packingtypesDropdownSettings = {
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        defaultOpen:false
    };

    SubPackingTypes = [];
    subTypeList = [
        {
            name: '',
            packing: []
        }
    ];

    // effective date
    date: Date = new Date();
    resetDateModel = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: (this.date.getDate() - 1) }
    effectivepDatePickerOptions: IMyOptions = {
        dateFormat: 'dd/mm/yyyy',
        disableUntil: this.resetDateModel
    };
    fromEffeciveDate: any;
    dateModel = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate()
    }

    constructor(
        private jhiAlertService: JhiAlertService,
        private loadingTypeService: LoadingTypeMySuffixService,
        private packingTypeService: PackingTypeMySuffixService,
        private activatedRoute: ActivatedRoute,
        private languageChangeService: LanguageChangeService,
        public principal: Principal,
        private modalService: BsModalService,
        private confirmationModelService: ConfirmationModelService,
        private orderPipe: OrderPipe
    ) { 
                this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
    }

    ngOnInit() {
        
        this.loadingTypeService.get("mode-of-conveyance-all").subscribe(res=>{
            this.mocTypesList = res.body;
        },err=>{})
        
        this.effectivepDatePickerOptions.disableUntil = this.principal.dateFormateServerToClientMin(this.date);
        
        this.isSaving = false;
        this.activatedRoute.data.subscribe(({ loadingType }) => {
            this.loadingType = loadingType;

            if(this.loadingType.isSubType){
                this.loadingType.packingTypeDTOs = [];
            } else {
                this.loadingType.loadingSubTypeDto = [];
            }
        });
        this.packingTypeService.queryForActive().subscribe(
            (res: HttpResponse<IPackingTypeMySuffix[]>) => {
                this.packingtypes = [];
                let packingTypes = [...res.body]
                let sortedData = this.orderPipe.transform(packingTypes, 'name', false, true);
                this.packingtypes = [...this.packingtypes, ...sortedData];
                console.log(this.packingtypes,"this.packingtypes===========");
                
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );

        $(document).ready(function () {
            $(document).on('click', '.form-control-multiselect', function () {
                $(this)
                    .find('.filter-textbox')
                    .find('input')
                    .focus();
            });
        });

        this.fromEffeciveDate = { date: this.dateModel };
    }

    searchAutoFocus() {
        $(document).on('click', '.form-control-multiselect', function () {
            $(this)
                .find('.filter-textbox')
                .find('input')
                .focus();
        });
    }

    onSubTypeSelect(event) {
        // this.loadingType.loadingSubTypeDto =
    }
    addSubType(isFirst) {
        const list = {
            name: '',
            packing: []
        };
        this.loadingType.packingTypeDTOs = [];
        this.loadingType.isSubType = true;
        let subtype = new LoadingSubTypeDto();
        if(isFirst){
            this.loadingType.loadingSubTypeDto = [];
        }
        this.loadingType.loadingSubTypeDto.push(subtype);
        // this.searchAutoFocus();
    }
    removeSubType(index: any) {
        // this.subTypeList.splice(index, 1);
        this.loadingType.loadingSubTypeDto.splice(index, 1);
    }

    // no subtype method
    noSubType() {
        this.subTypeList = [];
        this.loadingType.loadingSubTypeDto = [];
        this.loadingType.isSubType = false;
    }

    previousState() {
        window.history.back();
    }

    save(form) {
        // console.log(form.form.valid);
        // Sent string to backed from date object 
        let incDate = this.principal.dateFormateClientToServer(this.fromEffeciveDate.date);
        this.loadingType.fromEffectiveDate = incDate;
        this.openConfirmationModalForFutureRecordDeletion();
    }
    continueSaveAndUpdate(){
        this.saveOrUpdate();
        this.hideSubTypeRelation();
    }

    saveOrUpdate() {
        this.isSaving = true;
        // if (this.loadingType.id !== undefined) {
        if (CommonUtils.isNotNil(this.loadingType.id)) {
            if(!this.isWarningShown){
                this.showSubTypeRelation();
                return;
            }
            
            this.subscribeToSaveResponse(this.loadingTypeService.update(this.loadingType));
        } else {
            console.log('entity daata', this.loadingType);
            this.subscribeToSaveResponse(this.loadingTypeService.create(this.loadingType));
        }
    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<ILoadingTypeDto>>) {
        result.subscribe((res: HttpResponse<ILoadingTypeDto>) => this.onSaveSuccess(), (res: HttpErrorResponse) =>{
            this.isWarningShown = false;
            this.onSaveError();

            console.log(res);
            
        } );
    }

    private onSaveSuccess() {
        this.isSaving = false;
        this.deleteExistedFutureRecordDetails();
        this.previousState();
    }

    private onSaveError() {
        this.isSaving = false;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    trackPackingTypeById(index: number, item: IPackingTypeMySuffix) {
        return item.id;
    }

    getSelected(selectedVals: Array<any>, option: any) {
        if (selectedVals) {
            // for (let i = 0; i < selectedVals.length; i++) {
            //     if (option.id === selectedVals[i].id) {
            //         return selectedVals[i];
            //     }
            // }
            for (let _selectedVal of selectedVals) {
                if (option.id === _selectedVal.id) {
                    return _selectedVal;
                }
            }
        }
        return option;
    }
    get loadingType() {
        return this._loadingType;
    }

    set loadingType(loadingType: ILoadingTypeDto) {
        this._loadingType = loadingType;
    }

    trackLoadingSubTypeById(index: number, item: ILoadingSubTypeDto) {
        return index;
    }

    trimName(event) {
        if (this.loadingType.name) {
            this.loadingType.name = this.loadingType.name.trim();
        }
    }

    trimSubType(event, index) {
        if (this.loadingType.loadingSubTypeDto[index].name) {
            this.loadingType.loadingSubTypeDto[index].name = this.loadingType.loadingSubTypeDto[index].name.trim();
        }
    }
    // LanguageSelect
    onLanguageSelect(event, index) {
        $(document)
            .find('#packingTypeId' + index)
            .find('.dropdown-list')
            .addClass('showDropdown');
    }

    onLanguageDeSelect(event, index) {
        $(document)
            .find('#packingTypeId' + index)
            .find('.dropdown-list')
            .addClass('showDropdown');
    }
    onDropdownClose(event, index) {
        $(document)
            .find('#packingTypeId' + index)
            .find('.dropdown-list')
            .removeClass('showDropdown');
    }

    trimLoadingTypeName(event) {
        if (this.loadingType.name) { 
            this.loadingType.name = this.loadingType.name.trim();
        }
    }
    trimSubTypeName(event, index) {
        if (this.loadingType.loadingSubTypeDto[index].name) { 
            this.loadingType.loadingSubTypeDto[index].name = this.loadingType.loadingSubTypeDto[index].name.trim();
        }
    }

    //  $(document).find('.surveyCompanyPortClass .dropdown-list').addClass('showDropdown');
    //  $(document).find('.surveyCompanyPortClass .dropdown-list').removeClass('showDropdown');
    onDateChanged(event: IMyDateModel) {
        let selectedFromEffectiveDate = this.principal.dateFormateClientToServer(event.date)
        console.log('onDateChanged(): ', selectedFromEffectiveDate);
        // if (this.loadingType.id !== null && this.loadingType.id !== undefined) {
        if (CommonUtils.isNotNil(this.loadingType.id)) {
            let selectedFromEffectiveDate = this.principal.dateFormateClientToServer(event.date)
            console.log('onDateChanged(): ', selectedFromEffectiveDate);
            this.loadingTypeService.findByIdAndFromEffectiveDate(this.loadingType.id, selectedFromEffectiveDate).subscribe(response => {
                console.log(response);
                if (CommonUtils.isNotNil(response.body) && response.body['isSuccess']) {
                    this.loadingType = response.body['payLoad'];
                    if(this.loadingType.isSubType){
                        this.loadingType.packingTypeDTOs = [];
                    } else {
                        this.loadingType.loadingSubTypeDto = [];
                    }
                }
            });
        }
    }


    // global modal open and close event
    bsModalRef: BsModalRef;

    isConfirmDeletion = false;
    /* this is how we open a Modal Component from another component */
    openConfirmationModalForFutureRecordDeletion() {
        this.isConfirmDeletion = false;
        // if (this.loadingType.id !== null && this.loadingType.id !== undefined) {
        if (CommonUtils.isNotNil(this.loadingType.id)) {
            let form_data = {
                masterId: this.loadingType.id,
                futureDataType: FutureDataType.LOADING_TYPE.valueOf(),
                fromEffectiveDateFormatted: this.loadingType.fromEffectiveDate
            }
            this.confirmationModelService.findFutureRecordExisted(form_data).subscribe(response => {
                const resBody = response.body;
                if (resBody.isSuccess) {
                    const initialState = {
                        title: 'Loading Type (' + this.loadingType.name + ')',
                        message: resBody.message,
                    };
                    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, { initialState, class: "modal-lg" });
                    this.bsModalRef.content.onClose.subscribe(result => {
                        if (result) {
                            this.isConfirmDeletion = true;
                            this.saveOrUpdate();
                        }
                    });
                } else {
                    this.saveOrUpdate();
                }
            });

        } else {
            this.saveOrUpdate();
        }
    }


    deleteExistedFutureRecordDetails() {
        if (this.isConfirmDeletion) {
            let form_data = {
                masterId: this.loadingType.id,
                futureDataType: FutureDataType.LOADING_TYPE.valueOf(),
                fromEffectiveDateFormatted: this.loadingType.fromEffectiveDate
            }
            this.confirmationModelService.deleteExistedFutureRecord(form_data).subscribe(response => {
                console.log(response);
                this.isConfirmDeletion = false;
            });
        }
    }

    hideSubTypeRelation(){
        this.isWarningShown = false;
        this.subTypeRelation.hide();
    }

    showSubTypeRelation(){
        this.isWarningShown = true;
        this.subTypeRelation.show();
    }
}
